import moment from 'moment';

export const formatDate = (date: string | null | moment.Moment) => (date != null ? moment(date).format('DD. MM. YYYY') : null);
export const formatDateTime = (date: string | null | moment.Moment) => (date != null ? moment(date).format('DD. MM. YYYY HH:mm') : null);

export function toDateTimeStartOfDay<T extends string | null> (date: T): T extends string ? string : null;
export function toDateTimeStartOfDay (date: string | null) {
	return (date != null
		? moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
		: null);
}

export function toDateTimeEndOfDay<T extends string | null> (date: T): T extends string ? string : null;
export function toDateTimeEndOfDay (date: string | null) {
	return (date != null
		? moment(date).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
		: null);
}

export function toDateIso<T extends string | null | moment.Moment> (date: T): T extends string | moment.Moment ? string : null;
export function toDateIso (date: string | null | moment.Moment) {
	return (date != null
		? moment(date).format('YYYY-MM-DD')
		: null);
}

export const getTodayIsoDate = (): string => moment().format('YYYY-MM-DD');
